// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1406": "2fafa60e","1810": "e9d6c995","8457": "790bc4bf",}[chunkId] + ".css"
}